<template>
  <div class="page mt-80">
	  <title1 type="2" title="大数据模型" />

    <div class="my-footer mt-80">
      <swiper :options="swiperOptions">
        <swiper-slide
          style="width: 215px"
          v-for="(item, index) in list"
          :key="'list' + index"
        >
          <div class="target flex flex-direction align-items">
            <div class="imgBox">
              <img
                class="img mt-20"
                :src="
                  require(`@/assets/images/exposition/dashujumoxing/${
                    index + 1
                  }.png`)
                "
                alt=""
              />
              <div></div>
            </div>
            <div class="label">
              {{ item.label }}
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import title1 from '@/views/exposition/components/title2'
export default {
  components: {
    title1,
  },
  data() {
    return {
      list: [
        {
          label: "选址模型",
          subLabel: "效率",
          number: "200",
          uuid: "%",
          sort:1
        },
        {
          label: "站点健康模型",
          subLabel: "库存利用率",
          number: "40",
          uuid: "%",
          sort:1
        },
        {
          label: "排队预测模型",
          subLabel: "效率",
          number: "80",
          uuid: "%",
          sort:1
        },
        {
          label: "站点粘性模型",
          subLabel: "效率",
          number: "200",
          uuid: "%",
          sort:1
        },
        {
          label: "站点作业效率",
          subLabel: "风险",
          number: "30",
          uuid: "%",
          sort:2
        },
        {
          label: "套餐定价模型",
          subLabel: "安全率",
          number: "80",
          uuid: "%",
          sort:1
        },
        {
          label: "盈利评估模型",
          subLabel: "效率",
          number: "70",
          uuid: "%",
          sort:1
        },
		{
		  label: "车辆能耗模型",
		  subLabel: "效率",
		  number: "70",
		  uuid: "%",
		  sort:1
		}
      ],

      swiperOptions: {
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        speed: 500,
        slidesPerView: 4.7,
        spaceBetween: 0,
        centeredSlides: true,
        watchSlidesProgress: true,
      },
    };
  },
  mounted() {
    // this.list[0].number = this.generateRandomNumber(0,3)
    // this.list[1].number = this.generateRandomNumber(0,3)
    // this.list[2].number = this.generateRandomNumber(3,5)
    // this.list[3].number = this.generateRandomNumber(5,10)
    // this.list[4].number = this.generateRandomNumber(3,5)
    // this.list[5].number = this.generateRandomNumber(20,25)
  },
  methods: {
    generateRandomNumber(min, max) {
      var randomNumber = Math.random() * (max - min) + min;
      return Math.floor(randomNumber);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/comm.scss";
.page {
  height: 480px;
}
.my-footer {
  // width: 100%;
  height: 305px;
  .swiper-container {
    height: 100%;
    // background-color: pink;
    width: 1150px;
    // height: 215.37px;
  }

  .swiper-slide {
    .item-c-at {
      display: none;
    }
  }

  .swiper-slide-active {
    .item {
      .item-c {
        display: none;
      }

      .item-c-at {
        display: block;
      }

      .item-v {
        height: 80px;
        margin-top: -80px;

        > span {
          color: #00fdf4;
          font-size: 96px;
        }
      }
    }
  }
}

.target {
  .label {
    font-size: 30px;
  }
  .imgBox {
    position: relative;
	.img{
		width: 160px;
		height: 160px;
	}
  }
}
</style>